<fieldset class="rating-row" role="radiogroup" [attr.aria-labelledby]="'question-' + questionId()">
  <legend class="rating-row-question">
    <p class="question-name" [id]="'question-' + questionId()">
      {{ question() }}
      <span aria-hidden="true" class="required-asterisk">*</span>
      <span class="visually-hidden">(Required)</span>
    </p>
  </legend>
  <div class="rating-row-options" #rowContainer [class.rating-row-options-dimmed]="dimmed()">
    @for (label of labels; track $index) {
      <div class="rating-row-option">
        <input
          type="radio"
          [id]="optionId($index)"
          [name]="questionId()"
          [value]="$index"
          [checked]="selectedIndex() === $index"
          (change)="onSelect($index)"
          class="visually-hidden-but-still-focusable"
          [aria-label]="label"
        />

        <label
          [for]="optionId($index)"
          class="emoji-btn"
          [class.emoji-active]="selectedIndex() === $index"
          [style.transform]="animIndex() === $index ? transformStyle() : null"
          [class.emoji-anim]="animIndex() === $index"
          #emojiBtn
        >
          <div class="emoji-images" aria-hidden="true">
            <img
              class="emoji-img emoji-img-before"
              [src]="('assets/icons/review-emoji/' + label + '-before.svg') | deployUrl"
              [alt]="label + '-before'"
              width="48"
              height="48"
            />
            <img
              class="emoji-img emoji-img-after"
              [src]="('assets/icons/review-emoji/' + label + '-after.svg') | deployUrl"
              [alt]="label + '-after'"
              width="48"
              height="48"
            />
          </div>
        </label>
      </div>
    }
  </div>
</fieldset>